import { useParams, Navigate } from 'react-router-dom';
import { getCalculatorBySlugForClient } from '@/lib/calculator-data';
import { CalculatorClientPage } from '@/components/calculators/CalculatorClientPage';
import { calculatorDefinitions } from '@/lib/calculator-definitions';
import { CalculatorSeoContent } from '@/components/calculators/CalculatorSeoContent';
import { useSEO } from '@/hooks/useSEO';

export default function Calculator() {
  const { slug } = useParams<{ slug: string }>();
  const calculator = getCalculatorBySlugForClient(slug!);

  useSEO(
    calculator?.name || 'Calculator Not Found',
    calculator?.description || ''
  );

  if (!calculator) {
    return <Navigate to="/" replace />;
  }

  const definition = (calculatorDefinitions as any)[slug!];
  const content = definition?.seoContent ? <CalculatorSeoContent seoContent={definition.seoContent} /> : null;
  
  return (
    <>
      <CalculatorClientPage calculator={calculator} content={content} />
      <div className="container mx-auto px-4 mt-12">
        <div
          className="w-full max-w-[728px] h-[90px] bg-gray-200/50 rounded-lg flex items-center justify-center text-transparent text-sm mx-auto"
          data-ad-slot="calculator-page-leaderboard"
          aria-label="Advertisement"
        >
          Advertisement
        </div>
      </div>
    </>
  );
}